import React from 'react'
import Switch from 'react-switch'
import Spinner from './Spinner'
import { Toaster } from 'react-hot-toast'
import { notifyError } from './ToastMessages'
import { connect } from 'react-redux'

class ReviewTrackers extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            showSpinner: false,
            spinnerState: 'sync',
            spinnerText: '',
            status: {
                account: false,
                businesses: {},
                users: {}
            }
        }

        this.handleBusinessChange = this.handleBusinessChange.bind(this)
        this.handleEmployeeChange = this.handleEmployeeChange.bind(this)
        this.handleBusinessGroupChange = this.handleBusinessGroupChange.bind(this)
    }

    componentDidMount () {
        this.startSpinner()
        fetch(`/admin/business-group/${this.props.businessGroup.id}/realtime-reviews/sync`).then(resp => resp.json()).then(data => {
            this.setState({
                status: data
            })
        }).finally(() => this.stopSpinner())
    }

    startSpinner () {
        this.setState({
            showSpinner: true,
            spinnerState: 'sync',
            spinnerText: __('Please wait while we sync your data')
        })
    }

    stopSpinner () {
        this.setState({
            spinnerState: 'success',
            spinnerText: __('Sync complete')
        })
        setTimeout(() => {
            this.setState({
                showSpinner: false,
                spinnerState: 'sync',
                spinnerText: ''
            })
        }, 1500)
    }

    updateStatus () {
        fetch(`/admin/business-group/${this.props.businessGroup.id}/realtime-reviews/status`).then(resp => resp.json()).then(data => {
            this.setState({
                status: data
            })
        })
    }

    handleBusinessGroupChange () {
        this.startSpinner()
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        fetch(`/admin/business-group/${this.props.businessGroup.id}/realtime-reviews/toggle`, {
            method: 'POST',
            headers: headers
        }).then(response => {
            if (response.status > 299) {
                notifyError('There was a problem updating the business group')
            }
        }).catch(() => {
            notifyError('There was a problem updating the business group')
        }).finally(() => {
            this.updateStatus()
            this.stopSpinner()
        })
    }

    handleBusinessChange (businessId) {
        this.startSpinner()
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        fetch(`/admin/business-group/${this.props.businessGroup.id}/realtime-reviews/business/${businessId}/toggle`, {
            method: 'PUT',
            headers: headers
        }).then(response => {
            if (response.status > 299) {
                notifyError('There was a problem updating the business')
            }
        }).catch(() => {
            notifyError('There was a problem updating the business')
        }).finally(() => {
            this.updateStatus()
            this.stopSpinner()
        })
    }

    handleEmployeeChange (userId) {
        this.startSpinner()
        const headers = new Headers()
        headers.append('Content-Type', 'application/json')
        fetch(`/admin/business-group/${this.props.businessGroup.id}/realtime-reviews/user/${userId}/toggle`, {
            method: 'PUT',
            headers: headers
        }).then(response => {
            if (response.status > 299) {
                notifyError('There was a problem updating the employee')
            }
        }).catch(() => {
            notifyError('There was a problem updating employee')
        }).finally(() => {
            this.updateStatus()
            this.stopSpinner()
        })
    }

    render () {
        {/* toggle options */}
        const switchOptions = {
            className: 'rtf-toggle-switch',
            offColor: '#fff',
            onColor: '#1D71B8',
            offHandleColor: '#1D71B8',
            onHandleColor: '#fff',
            handleDiameter: 14,
            uncheckedIcon: false,
            checkedIcon: false,
            height: 24,
            width: 40
        }

        console.log(this.props);

        return (
            <div className="w-100 right-side-content">
                <div className="main-section">
                    <div className="col-12 mt-3">

                        {/* Content */}
                        <div className="card">
                            <div className="card-body">
                                <div className='row align-items-center'>
                                    <button className="btn btn-xs btn-outline-primary ml-2 mr-3" onClick={() => history.go(-1)}>{__('Back')}</button>
                                    <h2 className='mb-0'>{__(this.props.title + ' ' + 'settings for ') + this.props.businessGroup.name}</h2>
                                </div>
                                <p>{__('Global settings for ' + this.props.realTimeReviewsLabel + '. The page will automatically save on each action.')}</p>

                                {/* Business Group Toggle */}
                                <div className="w-100 row mt-5 mr-0 mb-2 ml-0">
                                    <label className="row align-items-center m-0">
                                        <Switch
                                            onChange={this.handleBusinessGroupChange}
                                            checked={this.state.status.account}
                                            {...switchOptions}
                                        />
                                        <h4 className="mr-4 mb-0">{__('Enable ' + this.props.realTimeReviewsLabel + ' for this business group')}</h4>
                                    </label>
                                </div>

                                {/* MSAs Toggle */}
                                <div className="w-100 row mt-5 mr-0 mb-2 ml-0">
                                    <h3>{__('Multisite Admins')}</h3>
                                    {this.props.businessGroup.businessgroupusers.map((businessgroupuser, userIndex) => (
                                        <div className="w-100 row mr-0 mb-2 ml-0" key={userIndex}>
                                            <label className="row align-items-center mr-0 mb-2 ml-0">
                                                <Switch
                                                    onChange={checked => this.handleEmployeeChange(businessgroupuser.user.user_id)}
                                                    checked={this.state.status.users[`${businessgroupuser.user.user_id}`] || false}
                                                    disabled={!this.state.status.account}
                                                    {...switchOptions}
                                                />
                                                <h4 className="mr-4 mb-0">{`${businessgroupuser.user.firstname} ${businessgroupuser.user.lastname}`}</h4>
                                            </label>
                                        </div>
                                    ))}
                                </div>

                                {/* Regional Managers Toggle */}
                                <div className="w-100 row mr-0 mb-2 ml-0">
                                    <h3>{__('Regional Managers')}</h3>
                                    {this.props.businessGroup.regions.map((region) => (
                                        region.users.map((regionalUser, userIndex) => (
                                        <div className="w-100 row mr-0 mb-2 ml-0" key={userIndex}>
                                            <label className="row align-items-center mr-0 mb-2 ml-0">
                                                <Switch
                                                    onChange={checked => this.handleEmployeeChange(regionalUser.user_id)}
                                                    checked={this.state.status.users[`${regionalUser.user_id}`] || false}
                                                    disabled={!this.state.status.account}
                                                    {...switchOptions}
                                                />
                                                <h4 className="mr-4 mb-0">{`${regionalUser.firstname} ${regionalUser.lastname}`}</h4>
                                            </label>
                                        </div>
                                    ))))}
                                </div>

                                {/* Businesses Toggles */}
                                <h3>{__('Businesses')}</h3>
                                {this.props.businessGroup.businesses.map((business, businessIndex) => (
                                    <div key={businessIndex}>
                                        <div className="w-100 row mb-3 mr-0 mb-2 ml-0">
                                            <label className="row align-items-center m-0">
                                                <Switch
                                                    onChange={checked => this.handleBusinessChange(business.business_id)}
                                                    checked={this.state.status.businesses[business.business_id] || false}
                                                    disabled={!this.state.status.account}
                                                    {...switchOptions}
                                                />
                                                <h4 className="mr-4 mb-0">{`${business.name} - ${business.address}`}</h4>
                                            </label>
                                        </div>
                                        <div className="d-inline-block mb-4 ml-0">
                                            {business.users.filter(user => !user.is_dummy).map((user, userIndex) => (
                                                <label key={userIndex}
                                                       className="row align-items-center mr-0 mb-2 ml-0">
                                                    <Switch
                                                        onChange={checked => this.handleEmployeeChange(user.user_id)}
                                                        checked={this.state.status.users[`${user.user_id}`] || false}
                                                        disabled={!(this.state.status.businesses[business.business_id] || false)}
                                                        {...switchOptions}
                                                    />
                                                    <span
                                                        className="mr-4">{`${user.firstname} ${user.lastname} - ${user.title}`}</span>
                                                </label>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Spinner */}
                        {this.state.showSpinner &&
                            <Spinner spinnerState={this.state.spinnerState} spinnerText={this.state.spinnerText}/>
                        }

                        {/* Toast */}
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                duration: 5000,
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps (state) {
    return {
        businessGroup: state.businessGroup,
        title: state.title,
        realTimeReviewsLabel: state.realTimeReviewsLabel
    }
}

export default connect(mapStateToProps)(ReviewTrackers)
